<template>
  <div class="maindfws" v-if="comeing">
    <div class="title-img">
      <div style="height:150px;width:100%;text-align:center" v-if="user">
        <div style="position: relative;top: 130px;">
          <img :src="user.headImgUrl||avader" class="avadar" style="margin-right:5px" alt />
          <span style="position:relative;top:13px">{{user.customerName}}  送你一套“爱包姐妹礼”</span>
        </div>
      </div>
      <img src="/images/mentionMe/2.png" class="imgs-show-co" @click="del_history" />

      <div class="main-fu">
        <div class="panel-get">
          <div class="header-dic">附赠礼品：大牌发卡一枚，见下图</div>
          <input type="text" name class="phone-fid" v-model="phone" placeholder="请输入手机号" />
          <div class="vilete-code">
            <input
              type="text"
              v-model="code"
              maxlength="16"
              placeholder="请输入验证码"
              name
              class="phone-code"
              ref="field"
            />
            <div
              class="sendCode t_center"
              @click="sendCode"
              v-if="!isSendCodeFlag"
            >{{ isSendCodeFlag ? reSendSecond + 's' : '发送验证码' }}</div>
            <div
              class="sendCodeNo t_center"
              v-if="isSendCodeFlag"
            >{{ isSendCodeFlag ? reSendSecond + 's' : '发送验证码' }}</div>
          </div>
          <div class="send-button" @click="getMoney">新用户一键领取</div>
        </div>
        <div class="fiuck">
          <img src="/images/mentionMe/3.png" alt style="width:293px;margin:0px 25px;" />
          <div class="sister-list-dl">
            领取即同意
            <router-link to="/agreement?type=three">
              <span class="quan">《包拯用户条款》</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <img src="/images/mentionMe/11.png" class="imgs-show" @click="del_history" />
    <!-- <div class="main-bottun">
      <div style="height:220px;"></div>
      <div
        class="what-disc"
      >迪士尼出逃公主们都有一枚特别的发卡，当你的姐妹领取并使用了这张代金券，你和TA都可以获得一枚大牌真皮发卡（总量1000枚，每人限领一枚，先到先得），想和姐妹一起把大牌戴在头上酷美逛街吗？</div>
    </div>-->
    <div class="friend-list">
      <div style="width:100%;height:120px" v-if="!isIos"></div>
      <div style="width:100%;height:210px" v-if="isIos"></div>
      <img src="/images/mentionMe/reset2.png" class="title-img-d" alt />
      <img src="/images/mentionMe/reser-title.png" class="title-img-2" alt />
      <img src="/images/mentionMe/rest3.png" class="title-img-3" alt />
    </div>
    <div>
      <!--视频模块-->
      <section class="videoWrap">
        <video :src="videoSrc" ref="myVideo" v-show="isPlay"></video>
        <img src="/images/mentionMe/muzhi5.png" v-show="!isPlay" class="title-img-5" @click="playVideo" alt />
      </section>
    </div>
    <div class="line-geli"></div>
    <div class="active-panel">
      <div class="title-fij">
        <span>他们刚刚让心爱之物焕新</span>
      </div>
      <div v-if="newGoods.length<4">
        <div
          style="margin:5px 20px;width:100%;line-height:20px;height:30px"
          v-for="(f, index) in newGoods"
          v-bind:key="index"
        >
          <van-col span="4">
            <img class="avadar" :src="f.headImg" alt />
          </van-col>
          <van-col span="4">
            <div style="text-align:left;line-height:20px">{{f.nickName}}</div>
          </van-col>
          <van-col span="16">
            <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
          </van-col>
        </div>
      </div>
      <div v-if="newGoods.length>3">
        <van-swipe vertical class="notice-swipe2" :autoplay="3000" :show-indicators="false">
          <van-swipe-item v-for="(obj, index) in showAlist" v-bind:key="index">
            <div
              style="margin:5px 20px;width:100%;line-height:20px;height:40px"
              v-for="(f, index) in obj"
              v-bind:key="index"
            >
              <van-col span="4">
                <img class="avadar" :src="f.headImg" alt />
              </van-col>
              <van-col span="4">
                <div style="text-align:left;line-height:20px">{{f.nickName}}</div>
              </van-col>
              <van-col span="16">
                <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
              </van-col>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="line-geli"></div>
    <div style="height:230px">
      <img src="/images/mentionMe/few78.png" class="title-img-8" alt />
      <img :src="codeImg" class="title-img-code" alt />
      <!-- <img src="https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/img/203.jpg" class="title-img-code" alt /> -->
    </div>
    <div style="width:100%;height:50px"></div>

    <!-- <div class="yaopqing"  @click="hidePop">
      <img src="/images/mentionMe/seccseIcon.png" alt="xiaog" />
    </div>-->

    <van-popup
      round
      close-icon="close"
      closeable
      close-icon-position="top-left"
      v-model="shareFlag"
    >
      <img src="/images/mentionMe/cha.png" alt="xiaog" class="chad" @click="closePop" />
      <img src="/images/mentionMe/seccseIcon.png" alt="xiaog" class="yaopqing" />
      <img :src="codeImg" class="pop-img-code" alt />
    </van-popup>
  </div>
</template>

<script>
import publicObj from "@/assets/js/public";
import callmeApi from "@/axios/callme";
import wxShare from "@/assets/js/wx.share";
import loginApi from "@/axios/login";
import { Toast } from "vant";
import { setTimeout } from "timers";
import zhugeObj from "@/assets/js/track";
const TIME_COUNT = 60;
export default {
  name: "recipientIndex",
  data() {
    return {
      account: "",
      code: "",
      showAlist: [],
      newGoods: [],
      iconFlag: [],
      user: { headImgUrl: null },
      openId: "",
      account: true,
      videoSrc:'https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/video/bz_release_2020727134553.mp4',
      servicePhoneId:'0',
      shareFlag: false,
      isPlay:false,
      submitFlag:false,
      comeing:false,
      getZuge:true,
      isSendCodeFlag: false,
      reSendSecond: TIME_COUNT,
      avader: "/images/mentionMe/default_avatar.92027116.png",
      checkRadio: true,
      autoLogin: false,
      codeImg: "",
      goodsData: {
        goodsImageList: [
          "https://baozheng-front.oss-cn-beijing.aliyuncs.com/2020/03/26/e81a3be4-7498-4b94-bfdd-7e6e28500310.jpg"
        ]
      },
      phone: "",
      submitImageList: []
    };
  },
  watch: {},
  computed: {
    token() {
      return this.$store.state.token;
    },
    isIos(){
      return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
    }
  },
  created() {
    //如果是微信环境
  },
  mounted() {
    zhugeObj.track({
        title : '提我-领取者页一键领取按钮曝光',
      })
    this.servicePhoneId = this.$route.query.servicePhoneId;
    this.invitedCustomerId = this.$route.query.invitedCustomerId;
    this.getNewGoods();
    this.getUserById();
    this.getServiceCode();
    let isr = this.$route.query.isr;
    if (isr == 1) {
      
      this.phone = localStorage.getItem("phone");
      this.code = localStorage.getItem("code");
      this.getMoney();
    }
    window.onscroll = () => {
      //为了保证兼容性，这里取两个值，哪个有值取哪一个
      //scrollTop就是触发滚轮事件时滚轮的高度
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if(this.getZuge&&scrollTop > 300){
        this.getZuge=false
        zhugeObj.track({
          title : '提我 - 新用户发卡曝光'
        })
      }
    };
  },
  methods: {
    playVideo(){
        this.isPlay?
            this.$refs.myVideo.pause()
            :this.$refs.myVideo.play();
        this.isPlay = !this.isPlay
    },
    getkddin() {
      this.servicePhoneId = this.$route.query.servicePhoneId ;
      this.invitedCustomerId = this.$route.query.invitedCustomerId;
      // if (publicObj.isWeiXin()) {
      //   // alert('没有code');
      //   // console.log('未授权')
      //   //未授权 跳转授权页面

      const openId = localStorage.getItem("openId");
      const code =
        this.$route.query.code || publicObj.GetQueryString("code") || "";

      // alert('created: openId：'+openId+',code：'+code);
      //不存在openId去微信授权接口
      // alert('没有有OPENID');
      if (openId) {
        this.dontKnonw();
      } else {
        if (code) {
          loginApi
            .getAUthUrl({
              wxAuthorizeCode: code
            })
            .then(res => {
              localStorage.setItem("openId", res.openId);
              localStorage.setItem("unionId", res.unionId);
              this.openId = res.openId;
              this.dontKnonw();
            });
        } else {
          let params = {
            redirectUri:
              location.origin +
              "/mentionMe/recipt-index?isr=1&servicePhoneId=" +
              this.servicePhoneId +
              "&invitedCustomerId=" +
              this.invitedCustomerId
          };
          localStorage.setItem("phone", this.phone);
          localStorage.setItem("code", this.code);
          loginApi
            .authorizeUrl(params)
            .then(res => {
              location.replace(res);
            })
            .catch(() => {
              Toast("此活动需要你同意微信授权！");
            });
        }
      }
    },
    getUserById() {
      let parms = {
        uid: this.invitedCustomerId
      };
      callmeApi
        .getUserById(parms)
        .then(res => {
          this.comeing = true
          this.user = res||{ headImgUrl: null };
          console.log(res);
        })
        .catch(res => {});
    },
    closePop() {
      this.shareFlag = false;
    },
    getServiceCode() {
      let parms = {
        servicePhoneId: this.servicePhoneId||'0'
      };
      callmeApi
        .getServiceCode(parms)
        .then(res => {
          this.codeImg = res;
        })
        .catch(res => {});
    },
    getMoney() {
      let { phone } = this;
      zhugeObj.track({
        title : '提我-领取者页一键领取按钮点击',
        content : {
          '手机号码' :phone
        }
      })
      this.getkddin();
    },
    dontKnonw() {
      let { phone, code, submitFlag } = this;
      if(submitFlag){
        return
      }
      submitFlag = true
      if (!code) {
        Toast("请填写验证码！");
        return;
      }
      if (!phone) {
        Toast("请填写手机号！");
        return;
      }
      let parms = {
        openId: localStorage.getItem("openId"),
        mobile: phone,
        code,
        activityId: 135,
        invitedCustomerId: this.invitedCustomerId
      };
      callmeApi
        .receiveGift(parms)
        .then(res => {
          zhugeObj.track({
            title : '提我-领取成功',
            content : {
              '手机号码' :phone
            }
          })
          localStorage.setItem("phone", this.phone);
          localStorage.setItem("code", this.code);
          localStorage.setItem("shareFlag", true);
          this.shareFlag = true;
          this.submitFlag = false
        })
        .catch(res => {
          this.shareFlag = false;
        });
    },
    getNewGoods() {
      callmeApi
        .getNewGoods()
        .then(res => {
          this.newGoods = res;
          let lenth = res.length;
          let array = [];
          for (let i = 0; i < lenth - 3; i = i + 4) {
            let list = [];
            list.push(res[i]);
            i + 1 < lenth && list.push(res[i + 1]);
            i + 2 < lenth && list.push(res[i + 2]);
            i + 3 < lenth && list.push(res[i + 3]);
            array.push(list);
          }
          this.showAlist = array;
        })
        .catch(res => {});
    },
    sendCode() {
       let mobile = this.phone;
      if (!mobile) {
        Toast("请填写手机号！");
        return null;
      }
      const _this = this;
      if (this.isSendCodeFlag) {
        return null;
      }
      _this.isSendCodeFlag = true;
      let interval = setInterval(() => {
        _this.reSendSecond--;
        if (_this.reSendSecond === 0) {
          _this.isSendCodeFlag = false;
          _this.reSendSecond = TIME_COUNT;
          clearInterval(interval);
        }
      }, 1000);
      callmeApi
        .sendCode({ mobile })
        .then(res => {
          Toast("发送成功！");
          _this.$refs.field.focus();
        })
        .catch(res => {
          clearInterval(interval);
          _this.reSendSecond = TIME_COUNT;
          _this.isSendCodeFlag = false;
        });
    },
    openRuls() {
      this.isActive = !this.isActive;
    },
    del_history() {
      console.log(333333);
    }
  }
};
</script>

<style scoped lang="scss">
.maindfws {
  // position: fixed;
  // top:0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 100%;
  background-color: #def2f2;
}
.imgs-show {
  width: 100%;
}
.imgs-show-co {
  display: block;
  width: 686px;
}

.title-img {
  height: 0;
  width: 686px;
  position: relative;
  left: calc(50% - 343px);
  // top: 4rem;
  z-index: 999;
}
.main-fu {
  height: 450px;
  background-color: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
.send-button {
  width: 420px;
  height: 84px;
  margin-top: 40px;
  background: #63bfbf;
  border-radius: 42px;
  position: relative;
  left: calc(50% - 210px);
  font-size: 44px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #fff;
  line-height: 84px;
  text-align: center;
}
img {
  vertical-align: top;
}
.sister-list-dl {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  text-align: center;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
  padding: 25px 0 50px 0;
}
.sister-list-dl-fg {
  position: relative;
  left: 40px;
  width: calc(100% - 80px);
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
}
.sister-list-dl-e {
  position: relative;
  left: calc(50% - 266px);
  width: 532px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  padding: 25px 0 50px 0;
}
.sister-list {
  position: relative;
  left: calc(50% - 160px);
  width: 320px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
  padding: 50px 0;
}
.quan {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: #f56d6d;
}
.what-disc {
  width: calc(100% - 80px);
  padding: 0 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
  text-align: left;
  line-height: 40px;
  padding-bottom: 40px;
}
.main-bottun {
  width: 100%;
}
.title-fij {
  margin: 40px 0 40px 0;
  width: 100%;
  text-align: center;
  height: 58px;
}
.title-fij span {
  font-size: 42px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
  line-height: 29px;
}
.friend-list {
  margin: 0 40px;
      height: 100%;
  width: calc(100% - 80px);
  // margin-top: 450px;
  overflow: scroll;
  background-color: #def2f2;
}
.title-img-d {
  width: 670px;
  height: 424px;
}
.show-or-less {
  text-align: center;
}
.show-or-less span {
  width: 112px;
  height: 20px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 166, 166, 1);
  line-height: 40px;
}
.imgr {
  width: 24px;
  height: 14px;
  vertical-align: middle;
  margin: 0 10px;
  position: relative;
  top: -2px;
}
.line-geli {
  width: 100%;
  height: 16px;
  background: rgba(212, 223, 223, 1);
}
.van-col {
  line-height: 72px;
  text-align: center;
}
.avadar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
}
.sic-ldss {
  width: 308px;
  margin: 30px calc(50% - 154px);
}
.sic-ldss span {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 30px;
}
.active-panel {
  padding: 50px;
}
.active-panel .acid {
  margin: 40px calc(50% - 210px);
  height: 84px;
  width: 410px;
}
.header-dic {
  width: 100%;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #63bfbf;
  line-height: 17px;
  text-align: center;
}
.panel-get {
  text-align: center;
  position: relative;
  top: -100px;
  width: 100%;
  background-color: #fff;
  color: #666666;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}
.sendCode {
  width: 180px;
  height: 76px;
  float: right;
  font-size: 24px;
  line-height: 76px;
  background: #333;
  border-radius: 10px;
  margin: 20px 0;
  color: #fff;
}
.phone-fid {
  width: 478px;
  height: 76px;
  line-height: 76px;
  background: #bfdddd;
  border-radius: 5px;
  opacity: 0.69;
  margin: 20px 0;
  color: #333;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}
.phone-code {
  width: 279px;
  height: 76px;
  background: #bfdddd;
  border-radius: 5px;
  opacity: 0.69;
  line-height: 76px;
  font-size: 32px;
  margin: 20px 0;
  float: left;
  color: #333;
}
.vilete-code {
  text-align: center;
  width: 538px;
  height: 100px;
  margin-left: calc(50% - 269px);
}
.fiuck {
  position: relative;
  top: -40px;
}
input {
  padding: 0 30px;
  font-size: 34px;
}
.sendCodeNo {
  width: 180px;
  height: 76px;
  float: right;
  font-size: 24px;
  line-height: 76px;
  background: #f0f0f0;
  border-radius: 10px;
  margin: 20px 0;
  color: #bebebe;
}
.title-img-2 {
  width: 266px;
  height: 152px;
  margin: 50px 0;
  margin-left: calc(50% - 133px);
}
.title-img-3 {
  width: 670px;
  height: 2060px;
}
.title-img-5 {
  width: 100%;
}
.title-img-8 {
  margin: 50px 0;
  margin-left: calc(50% - 177px);
  width: 354px;
  height: 448px;
}
.yaopqing {
  height: 820px;
  width: 654px;
}
.notice-swipe2 {
  height: 350px;
}
.title-img-code {
  width: 2.93333rem;
  height: 2.93333rem;
  position: absolute;
  margin-top: 180px;
  left: calc(50% - 1.46667rem);
}
.pop-img-code {
  width: 220px;
  height: 220px;
  position: absolute;
  top: 300px;
  left: calc(50% - 110px);
  z-index: 33333;
}
.chad {
  width: 20px;
  height: 20px;
  position: absolute;
  left: calc(100% - 50px);
  top: 30px;
  z-index: 33333;
}
.van-popup {
  border-radius: 10px;
}
/*视频模块*/
    .videoWrap{
        position: relative;
        video,.videoMask{width:100%;height: 650px;margin-bottom: 40px}
        .videoMask{
            position:absolute;left:0;top:0;
            /*color: #fff;*/
            /*img{width: .51rem;margin-top: 1.65rem}*/
            /*p{line-height: .48rem}*/
            >div{
                width:100%;height: 650px;
                background: url("/images/base/brandDetail_02.png") no-repeat left top;
                background-size: 100%;
            }

        }
        .arrow{width:40px;margin-bottom:50px;}

        .videoBotList{
            // padding:.62rem .2rem .27rem;
            padding-left:20px;
            padding-bottom: 20px;
            padding-top:30px;
            
            li{margin-bottom: 80px;opacity: .3;transition: .5s}
            h2{line-height: 55px;margin-bottom: 40px;font-size:45px;}
            p{line-height: 50px;color: #797979;font-size:32px;}
        }


        .list{
            padding:80px 80px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            li{
                width: 35%;
                margin-bottom: 80px;
                opacity: .3;
                transition: .5s
            }
            h2{
                line-height: 70px;
                font-size: 50px;
            }
            p{
                line-height: 40px;
                color: #797979;
                font-size: 30px

            }
        }

    }
</style>
